import { Checkbox } from "antd";
import React, { useEffect, useRef, useState } from "react";
import OTPInput from "react-otp-input";

const AadharVerification = (props) => {
  const [isAccountDisabled, setIsAccountDisabled] = useState(true);
  const isAadharVerified = props.$store?.user?.is_aadhar_verified;

  const handleAcknowledge = (e, data) => {
    let value = e.target.checked;
    setIsAccountDisabled(!value);
  };

  // ---------------- AADHAR DIGI-LOCKER FLOW ----------------
  const [aadharData, setAadharData] = useState(null);
  const [hasAadharData, setHasAadharData] = useState(false);
  const digiLockerWindowRef = useRef(null);

  const handleDigilockerLogin = (e) => {
    let callbackUrl = window.location.origin + "/open/digilockercallback";

    let payload = {
      callbackUrl,
    };
    props.apis
      .apiGetConnectorDigilockerUrlForUserConsent(payload)
      .then((res) => {
        console.log({ apiGetConnectorDigilockerUrlForUserConsent: res });

        if (res?.result) {
          sessionStorage.setItem("aadhaar_request_id", res?.result?.requestId);

          // Open DigiLocker in child tab
          digiLockerWindowRef.current = window.open(
            res?.result?.url,
            "DigiLockerTab",
            "width=1200,height=800"
          );
        }
      });
  };

  const fetchAadhaarData = async () => {
    props.apis.apiGetConnectorDetails().then((res) => {
      if (res) {
        let { uid, address } = res?.connector_aadhar_info || [];

        if (uid !== null) {
          setHasAadharData(true);
          setAadharData({
            uid,
            address,
          });
          props.store("user", {
            ...props?.$store?.user,
            is_aadhar_verified: true,
          });
        } else {
          setHasAadharData(false);
          props.onModalClose();
          swal2.fire({
            title: "Aadhaar Details Not Found",
            icon: "error",
            iconColor: "#FF4D4D",
          });
        }
      }
    });
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data === "digilocker_complete") {
        fetchAadhaarData();

        // Close child tab if still open
        if (
          digiLockerWindowRef.current &&
          !digiLockerWindowRef.current.closed
        ) {
          digiLockerWindowRef.current.close();
        }
      }
    };

    if (isAadharVerified) {
      fetchAadhaarData();
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <>
      {hasAadharData ? (
        <div className="profile_details_container">
          <div className="profile_detail mb-3">
            <p className="m-0">Aadhar no</p>
            <h4>{aadharData?.uid || "-"}</h4>
          </div>
          <div className="profile_detail mb-3">
            <p className="m-0">Address as per Aadhar</p>
            <h4>{aadharData?.address || "-"}</h4>
          </div>
          <div className="nav_container">
            <button
              className="formdata-cancel-btn btn"
              onClick={(...args) => props.onHandleStep(...args, 0)}
            >
              Back
            </button>
            <button
              className="btn btn-primary ms-3"
              onClick={(...args) => props.onHandleStep(...args, 2)}
            >
              Save & Next
            </button>
          </div>
        </div>
      ) : (
        <>
          <h4>Instruction to follow:</h4>
          <ul className="aadhar_instruction_ul mb-4">
            <li>
              Click on the below <span>Login to Digilocker</span> button.{" "}
            </li>
            <li>
              It will take you a new tab to enter your 12 digit Aadhar card
              number.
            </li>
            <li>
              Click <span>Next</span> and provide the OTP from the Aadhar card
              owner's phone.
            </li>
            <li>
              After clicking <span>Continue</span> button, accept{" "}
              <span>Signzy</span> access to <span>DigiLocker</span> by clicking
              on Allow button.
            </li>
          </ul>
          <Checkbox onChange={handleAcknowledge}>
            I hereby understand the above instructions and wiling to use this
            service.
          </Checkbox>

          <div className="d-flex mt-5 justify-content-end">
            <button
              className="formdata-cancel-btn btn"
              onClick={(...args) => props.onHandleStep(...args, 1)}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-primary ms-3"
              onClick={(...args) => handleDigilockerLogin(...args)}
              disabled={isAccountDisabled}
            >
              Login to Digilocker
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default constore(AadharVerification);
